export const allMathSymbolsByGlyph: Record<string, string> = {
  ' ': '\\textrm{ }',
  '∃': '\\exists',
  '∀': '\\forall',
  '⇔': '\\iff',
  '⇒': '\\Rightarrow',
  '¬': '\\neg',
  '□': '\\square',
  '⋄': '\\diamond',
  '△': '\\triangle',
  '⌢': '\\frown',
  '∠': '\\angle',
  '⋱': '\\ddots',
  '⋮': '\\vdots',
  '∵': '\\because',
  '∴': '\\therefore',
  ℵ: '\\aleph',
  '∅': '\\emptyset',
  '±': '\\pm',
  '∇': '\\nabla',
  '∂': '\\partial',
  '∮': '\\oint',
  '∫': '\\int',
  '⋃': '\\cup',
  '∪': '\\cup',
  '⋂': '\\cap',
  '∩': '\\cap',
  '⋁': '\\vee',
  '∨': '\\vee',
  '⋀': '\\wedge',
  '∧': '\\wedge',
  '∏': '\\prod',
  '∑': '\\sum',
  '⊙': '\\bigodot',
  '⊗': '\\bigoplus',
  '⊕': 'o+',
  '∘': '@',
  '⋈': '\\bowtie',
  '⋊': '\\rtimes',
  '⋉': '\\ltimes',
  '÷': '\\div',
  '×': '\\times',
  '\\': '\\backslash',
  '⋆': '\\star',
  '∗': '\\star',
  '⋅': '\\cdot',
  Ω: '\\Omega',
  ω: '\\omega',
  Ψ: '\\Psi',
  ψ: '\\psi',
  χ: '\\chi',
  φ: '\\varphi',
  Φ: '\\Phi',
  ϕ: '\\phi',
  υ: '\\upsilon',
  τ: '\\tau',
  Σ: '\\Sigma',
  σ: '\\sigma',
  ρ: '\\rho',
  Π: '\\Pi',
  π: '\\pi',
  Ξ: '\\Xi',
  ξ: '\\xi',
  ν: '\\nu',
  μ: '\\mu',
  Λ: '\\Lambda',
  λ: '\\lambda',
  κ: '\\kappa',
  ι: '\\iota',
  ϑ: '\\vartheta',
  Θ: '\\Theta',
  θ: '\\theta',
  η: '\\eta',
  ζ: '\\zeta',
  ɛ: '\\varepsilon',
  ε: '\\epsilon',
  Δ: '\\Delta',
  δ: '\\delta',
  Γ: '\\Gamma',
  γ: '\\gamma',
  β: '\\beta',
  α: '\\alpha',
  '∞': '\\infty',
  ϵ: '\\epsilon',
  µ: '\\mu',
  '²': '^{2}',
  ı: '\\imath',
  '∎': '\\blacksquare',
  ม: '\\mathbf{m}',
  Ω: '\\Omega',
  '⟲': '\\circlearrowleft',
  '⟳': '\\circlearrowright',
  त: ' ',
  '¥': '\\yen',
  '⁽': '^{(}',
  '⁾': '^{)}',
  ß: '\\ss',
  Ћ: '\\hbar',
  '⦵': '\\ominus',
  '⊿': '\\bigtriangleup',
  "↛'": '\\nrightarrow',
  '†': '\\dagger',
  เ: '\\prime',
  白: ' ',
  '⿱': ' ',
  ℸ: '\\wp',
  퓰: ' ',
  ⁿ: '^{n}',
  '✔': '\\checkmark',
  '✗': '\\times',
  '½': '\\dfrac{1}{2}',
  Ө: '\\theta',
  '✓': '\\checkmark',
  '⟩': '\\rangle',
  '⟨': '\\langle',
  '〈': '\\langle',
  '¼': '\\dfrac{1}{4}',
  '…': '\\ldots',
  ℏ: '\\hbar',
  ℜ: '\\mathfrak{R}',
  Ѳ: '\\theta',
  Ø: '\\emptyset',
  ϱ: '\\varrho',
  ф: '\\phi',
  T: 'T',
  '∙': '\\cdot',
  Ρ: 'P',
  ᐁ: '\\nabla',
  ƞ: '\\eta',
  ɣ: '\\gamma',
  ћ: '\\hbar',
  Ɛ: '\\varepsilon',
  ⅅ: '\\_{D}',
  𝜆: '\\lambda',
  '〗': '\\rangle',
  '〖': '\\langle',
  ';': ';',
  𝑥: 'x',
  𝑦: 'y',
  𝑧: 'z',
  𝑖: 'i',
  𝑗: 'j',
  𝑘: 'k',
  𝑚: 'm',
  𝑒: 'e',
  𝑟: 'r',
  ɳ: '\\eta',
  '𝛽': '\\beta',
  '⍵': '\\omega',
  '℘': '\\wp',
  '𝜋': '\\pi',
  Є: '\\epsilon',
  є: '\\epsilon',
  𝜀: '\\epsilon',
  п: '\\pi',
  Ν: '\\nu',
  ɵ: '\\theta',
  '𝜓': '\\psi',
  ϴ: '\\theta',
  ɸ: '\\phi',
  Ӷ: '\\Gamma',
  ɭ: '\\ell',
  ʋ: '\\upsilon',
  𝛟: '\\varphi',
  '⍬': '\\theta',
  Ф: '\\Phi',
  '𝜑': '\\varphi',
  ⅈ: 'i',
  ο: 'o',
  ơ: 'o',
  ƒ: 'f',
  '⍴': '\\rho',
  '🇽': 'x',
  '𝑝': 'p',
  '𝑞': 'q',
  '𝑠': 's',
  '𝑡': 't',
  '𝑢': 'u',
  '𝑣': 'v',
  '𝑤': 'w',
  '𝑎': 'a',
  '𝑏': 'b',
  '𝑐': 'c',
  '𝑑': 'd',
  '𝑓': 'f',
  '𝑔': 'g',
  '𝑙': 'l',
  '𝑛': 'n',
  '𝑜': 'o',
  '𝔀': 'w',
  '𝚟': 'v',
  ṁ: 'm',
  '൦': '\\circ',
  '┴': '\\perp',
  '✕': '\\times',
  '∣': '\\mid',
  Փ: '\\Phi',
  '⎜': '\\mid',
  ħ: '\\hbar',
  ፈ: ' ',
  '⦨': '\\llbracket',
  ế: '\\hat{e}',
  '¢': '\\cent',
  '⤹': '\\downarrow',
  '⤸': '\\downarrow',
  '⤷': '\\Rsh',
  '⤶': '\\Lsh',
  '⤵': '\\downarrow',
  '⤴': '\\uparrow',
  '⤳': '\\rightarrow',
  '|': '\\mid',
  '⎥': '\\mid',
  '♥': '\\heartsuit',
  О: '0',
  Υ: 'Y',
  х: 'x',
  𝓏: 'z',
  𝓎: 'y',
  𝓍: 'x',
  р: 'p',
  а: 'a',
  '£': '\\pounds',
  m: 'm',
  '𝚵': '\\Xi',
  '⓪': '\\textcircled{0}',
  '①': '\\textcircled{1}',
  '②': '\\textcircled{2}',
  '③': '\\textcircled{3}',
  '④': '\\textcircled{4}',
  '⑤': '\\textcircled{5}',
  '⑥': '\\textcircled{6}',
  '⑦': '\\textcircled{7}',
  '⑧': '\\textcircled{8}',
  '⑨': '\\textcircled{9}',
  '⑩': '\\textcircled{10}',
  '⑪': '\\textcircled{11}',
  '⑫': '\\textcircled{12}',
  '⑬': '\\textcircled{13}',
  '⑭': '\\textcircled{14}',
  '⑮': '\\textcircled{15}',
  '⑯': '\\textcircled{16}',
  '⑰': '\\textcircled{17}',
  '⑱': '\\textcircled{18}',
  '⑲': '\\textcircled{19}',
  '⑳': '\\textcircled{20}',
  '㉑': '\\textcircled{21}',
  '㉒': '\\textcircled{22}',
  '㉓': '\\textcircled{23}',
  '㉔': '\\textcircled{24}',
  '㉕': '\\textcircled{25}',
  '㉖': '\\textcircled{26}',
  '㉗': '\\textcircled{27}',
  '㉘': '\\textcircled{28}',
  '㉙': '\\textcircled{29}',
  '㉚': '\\textcircled{30}',
  '㉛': '\\textcircled{31}',
  '㉜': '\\textcircled{32}',
  '㉝': '\\textcircled{33}',
  '㉞': '\\textcircled{34}',
  '㉟': '\\textcircled{35}',
  '㊱': '\\textcircled{36}',
  '㊲': '\\textcircled{37}',
  '㊳': '\\textcircled{38}',
  '㊴': '\\textcircled{39}',
  '㊵': '\\textcircled{40}',
  '㊶': '\\textcircled{41}',
  '㊷': '\\textcircled{42}',
  '㊸': '\\textcircled{43}',
  '㊹': '\\textcircled{44}',
  '㊺': '\\textcircled{45}',
  '㊻': '\\textcircled{46}',
  '㊼': '\\textcircled{47}',
  '㊽': '\\textcircled{48}',
  '㊾': '\\textcircled{49}',
  '㊿': '\\textcircled{50}',
  '&': '\\&',
  '‖': '\\parallel',
  '%': '\\%',
  '“': '\\text{``}',
  $: '\\$',
  '#': '\\#',
  '℃': '\\text{\\textdegree C}',
  '℉': '\\text{\\textdegree F}',
  '█': '\\blacksquare',
  '℧': '\\mho',
  '⌋': '\\rfloor',
  '⌊': '\\lfloor',
  '⌉': '\\rceil',
  '⌈': '\\lceil',
  ℇ: '\\varepsilon',
  ⅇ: '\\text{e}',
  ɼ: 'r',
  '↛': '\\nrightarrow',
  ˆ: '\\hat{}',
  '‾': '\\overline',
  '→': '\\rightarrow',
  '‡': '\\ddagger',
  '・': '\\cdot',
  '▱': '\\square',
  '∆': '\\Delta',
  ἱ: 'i',
  '∡': '\\angle',
  ϒ: '\\Upsilon',
  '↓': '\\downarrow',
  '↑': '\\uparrow',
  '»': '\\gg',
  '⊤': '\\top',
  '⧸': '/',
  '𝛿': '\\delta',
  '˳': '\\cdot',
  '։': ':',
  '⦪': '\\measuredangle',
  '⦩': '\\measuredangle',
  '⦫': '\\measuredangle',
  '⦁': '\\cdot',
  ѳ: '\\theta',
  '⦢': '\\measuredangle',
  '¸': ',',
  '⎻': '\\overline',
  '⟦': '\\llbracket',
  '𝜙': '\\phi',
  П: '\\prod',
  о: 'o',
  '≈': '\\approx',
  '≤': '\\leq',
  ђ: '\\hbar',
  Ʌ: '\\Lambda',
  土: '\\pm',
  '⎼': '-',
  十: '+',
  '≠': '\\neq',
  '←': '\\leftarrow',
  '।': '\\mid',
  '€': '\\euro',
  '˘': ' ',
  ῡ: '\\bar{u}',
  '∥': '\\parallel',
  '↔': '\\leftrightarrow',
  '√': '\\sqrt{}',
  ȼ: 'c',
  '𝞮': '\\epsilon',
  '·': '\\cdot',
  '⦬': '\\measuredangle',
  '⦮': '\\measuredangle',
  '⦭': '\\measuredangle',
  '«': '\\ll',
  Χ: '\\mathsf{X}',
  '│': '\\mid',
  '〉': '\\rangle',
  ₙ: '_{n}',
  '▫': '\\square',
  '●': '\\circle',
  '”': '\\"',
};
